/**
 * Replicated from: ooui\packages\wac-browsertelemetry\src\diagnostics\api\ULSTraceLevel.ts
 * that is auto generated from: https://dev.azure.com/Office/Office/_git/Office?path=/browsertelemetry/Diagnostics/API/Levels.cs
 *
 * We can't re-export the ULSTraceLevel enum from there since its not capitalized.
 *
 * Log/Trace level to be written
 *
 * @enum {number}
 */
export var TraceLevel;
(function (TraceLevel) {
    /**
     * Error handling code paths, almost always unexpected, generally unrecoverable.
     * aka Unexpected
     */
    TraceLevel[TraceLevel["Error"] = 10] = "Error";
    /**
     * Generally used for error-handling code paths that are occasionally expected
     * and/or usually handled appropriately.
     * aka Monitorable
     */
    TraceLevel[TraceLevel["Warning"] = 15] = "Warning";
    /**
     * Important events happening on the box that don't indicate an error or warning,
     * but are still be worth monitoring.
     * aka High
     */
    TraceLevel[TraceLevel["Important"] = 20] = "Important";
    /**
     * Normal/expected code paths, used to indicate the "big" things that
     * are happening (e.g. activation, status updates).
     * aka Medium
     */
    TraceLevel[TraceLevel["Info"] = 50] = "Info";
    /**
     * Intended only for developers/testers for the purposes of debugging issues.
     */
    TraceLevel[TraceLevel["Verbose"] = 100] = "Verbose";
    /**
     * Generally not used, but expected to cause significant slow down (when on) and
     * significantly increase log size. Used only for debugging issues that are very
     * difficult to track down.
     * aka VerboseEx
     */
    TraceLevel[TraceLevel["Spam"] = 200] = "Spam";
})(TraceLevel || (TraceLevel = {}));
//# sourceMappingURL=TraceLevel.js.map